import React from "react";
import { ASSETS } from "../lib/brand";

/**
 * HavenBrand — site-wide upper-left logo per ruleset.
 * Compact circular sewing-machine mark + Cormorant Garamond wordmark.
 * (The full text-logo asset is featured in the hero & footer instead.)
 */
export const HavenBrand = ({ size = 40, withWordmark = true, onClick, className = "" }) => {
  return (
    <a
      href="/"
      onClick={onClick}
      data-testid="haven-brand"
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label="The Sewing Haven — home"
      style={{ textDecoration: "none" }}
    >
      <span
        className="inline-flex items-center justify-center rounded-full overflow-hidden"
        style={{
          width: size,
          height: size,
          background: "var(--warm-white)",
          border: "1px solid var(--border-soft)",
          boxShadow: "var(--shadow-soft)",
        }}
      >
        <img
          src={ASSETS.logoCompact}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          loading="eager"
        />
      </span>
      {withWordmark && (
        <span className="leading-tight">
          <span
            className="font-serif block"
            style={{ fontSize: 20, color: "var(--ink)", lineHeight: 1.1, letterSpacing: "-0.005em" }}
          >
            The Sewing Haven
          </span>
          <span
            className="block"
            style={{
              fontSize: 9.5,
              letterSpacing: "0.24em",
              textTransform: "uppercase",
              color: "var(--gold)",
              fontFamily: "Jost, sans-serif",
              marginTop: 1,
            }}
          >
            est. 2026 · Founding cohort
          </span>
        </span>
      )}
    </a>
  );
};

export default HavenBrand;
